import { render } from "./BlockUserModal.vue?vue&type=template&id=74ab5128&scoped=true&ts=true"
import script from "./BlockUserModal.vue?vue&type=script&lang=ts"
export * from "./BlockUserModal.vue?vue&type=script&lang=ts"

import "./BlockUserModal.vue?vue&type=style&index=0&id=74ab5128&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ab5128"]])

export default __exports__